import type { InputHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

type InputProps = {
  readonly className?: string;
} & InputHTMLAttributes<HTMLInputElement>;

export const Input = ({ className, ...rest }: InputProps) => {
  const classes = twMerge(
    "w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm placeholder:text-gray-400 focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-1",
    className
  );

  return <input className={classes} {...rest} />;
};

